module.exports = __webpack_public_path__ + "static/img/logo2.f91c0616.png";